import "./component-library185.mjs";
import normalizeComponent from "./component-library92.mjs";
const _sfc_main = {
  name: "BundleList",
  props: {
    items: { type: Array, required: true }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "bundle-list" }, _vm._l(_vm.items, function(item, index) {
    return _c("div", { key: index, staticClass: "bundle-list__item" }, [_c("div", { staticClass: "bundle-list__product-image" }, [_vm._t("image", null, { "item": item })], 2), _c("div", { staticClass: "bundle-list__name", domProps: { "innerHTML": _vm._s(item.name) } })]);
  }), 0);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "e1f4fa86",
  null,
  null
);
const bundleList = __component__.exports;
export {
  bundleList as default
};
